import React from "react";
import { capitalizeFirstLetter } from "../../utils/utils";
import { Link } from "react-router-dom";
import { Spinner } from "reactstrap";
import { singularRoleLabels } from "../../constants";


const UserInfoCard = ({
  info,
  role,
  linkToProfile,
  invitedByUserId,
  icon,
  otherProps,
  montlyCommission,
}) => (
  <div className="d-flex justify-content-start align-items-center mb-2">
    <div className="border rounded-4 d-flex flex-column align-items-start p-3  w-100">
      <div className="d-flex justify-content-between align-items-center w-100">
        <h5>
          {montlyCommission
            ? "My Monthly Commissions"
            : singularRoleLabels[role]}{" "}
          :
        </h5>
        {icon && (
          <div className="bg bg-soft-primary p-1 border rounded">
            <img src={icon} alt="group" />
          </div>
        )}
      </div>
      {linkToProfile ? (
        <Link
          className="text-decoration-none"
          to={`/${linkToProfile(role)}/${info?.id}`}
        >
          <span className="mb-2 fs-4 ms-2 text-hover-underlined text-hover-primary">
            {info?.companyName
              ? info?.companyName
              : `${info?.firstName} ${info?.lastName}`}
          </span>
        </Link>
      ) : (
        <span className="mb-2 fs-4 ms-2 text-primary">
          {info?.companyName
            ? info?.companyName
            : `${info?.firstName} ${info?.lastName}`}{" "}
          {otherProps ? otherProps?.loadingCommissions ? (
            <Spinner size="md" color="primary" className="ms-1" />
          ) : (
            "$" + otherProps.firstCommission || ""
          ) : null}
        </span>
      )}
    </div>
  </div>
);
export default UserInfoCard;
